import React from "react";
import Icon from "../../../components/AppIcon";

const HeroMetrics = () => {
  const metrics = [
    {
      icon: "Code2",
      value: "4+",
      label: "Projects Delivered",
      color: "text-conversion-accent",
    },
    {
      icon: "Calendar",
      value: "1+",
      label: "Years Experience",
      color: "text-trust-builder",
    },
    // {
    //   icon: 'Users',
    //   value: '25+',
    //   label: 'Happy Clients',
    //   color: 'text-cta'
    // },
    // {
    //   icon: 'Award',
    //   value: '15+',
    //   label: 'Technologies',
    //   color: 'text-success'
    // }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-12 mb-5">
      {metrics?.map((metric, index) => (
        <div
          key={index}
          className="group relative bg-card/50 backdrop-blur-sm border border-border/50 rounded-lg p-4 hover:bg-card/70 transition-smooth hover:scale-105"
        >
          <div className="flex flex-col items-center text-center space-y-2">
            <div
              className={`p-2 rounded-lg bg-muted/30 ${metric?.color} group-hover:scale-110 transition-smooth`}
            >
              <Icon name={metric?.icon} size={20} />
            </div>
            <div className="space-y-1">
              <div className={`text-2xl font-bold font-mono ${metric?.color}`}>
                {metric?.value}
              </div>
              <div className="text-xs text-muted-foreground font-medium">
                {metric?.label}
              </div>
            </div>
          </div>

          {/* Hover Effect */}
          <div className="absolute inset-0 rounded-lg bg-gradient-to-br from-conversion-accent/5 to-trust-builder/5 opacity-0 group-hover:opacity-100 transition-smooth" />
        </div>
      ))}
    </div>
  );
};

export default HeroMetrics;
